import Api from "@/services/api";
import {
	LOAD_TERMINAL,
	CREATE_TERMINAL,
	EDIT_TERMINAL,
	REMOVE_TERMINAL,
	REMOVE_TERMINALS,
	ADD_ALERT,
} from "@/store/_actiontypes";
import {
	SET_TERMINAL,
	ADD_TERMINAL,
	UPDATE_TERMINAL,
	DELETE_TERMINAL,
} from "@/store/_mutationtypes";

const state = {
	terminallist: [],
};

const actions = {
	[LOAD_TERMINAL]({ commit }) {
		Api.get("/terminal").then((response) => {
			let item = response.data;
			commit(SET_TERMINAL, item);
		});
	},
	[CREATE_TERMINAL]({ commit, dispatch }, { item }) {
		return Api.post("/terminal", {
			name: item.name,
			code: item.code,
			pinKeyId: item.pinKeyId,
			pinKeyName: item.pinKeyName,
			macKeyId: item.macKeyId,
			macKeyName: item.macKeyName,
			dataKeyId: item.dataKeyId,
			dataKeyName: item.dataKeyName,
			pinSessionKey: item.pinSessionKey,
			macSessionKey: item.macSessionKey,
			dataSessionKey: item.dataSessionKey,
			shiftNumber: item.shiftNumber,
			batchNumber: item.batchNumber,
			sequenceNumbe: item.sequenceNumbe,
			responsCodeId: item.responsCodeId,
		}).then((response) => {
			let item = response.data;
			commit(ADD_TERMINAL, item);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Terminal added successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[EDIT_TERMINAL]({ commit, dispatch }, { item }) {
		return Api.put(`/terminal/${item.id}`, item).then((response) => {
			let item = response.data;
			commit(UPDATE_TERMINAL, item);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Terminal updaded successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_TERMINAL]({ commit, dispatch }, { id }) {
		Api.delete(`/terminal/${id}`).then(() => {
			commit(DELETE_TERMINAL, id);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Terminal deleted successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_TERMINALS]({ commit, dispatch }, { ids }) {
		ids.forEach((id) => {
			Api.delete(`/terminal/${id}`).then(() => {
				commit(DELETE_TERMINAL, id);
			});

			dispatch(
				`alert/${ADD_ALERT}`,
				{
					message: `Successfully deleted ${ids.lenght} terminals`,
					color: "success",
				},
				{ root: true }
			);
		});
	},
};

const mutations = {
	[SET_TERMINAL](state, item) {
		state.terminallist = item;
	},
	[ADD_TERMINAL](state, item) {
		state.terminallist.push(item);
	},

	[UPDATE_TERMINAL](state, item) {
		let lVar = state.terminallist.find((h) => h.id == item.id);
		lVar.name = item.name;
		lVar.code = item.code;
		lVar.pinKeyId = item.pinKeyId;
		lVar.pinKeyName = item.pinKeyName;
		lVar.macKeyId = item.macKeyId;
		lVar.macKeyName = item.macKeyName;
		lVar.dataKeyId = item.dataKeyId;
		lVar.dataKeyName = item.dataKeyName;
		lVar.pinSessionKey = item.pinSessionKey;
		lVar.macSessionKey = item.macSessionKey;
		lVar.dataSessionKey = item.dataSessionKey;
		lVar.shiftNumber = item.shiftNumber;
		lVar.batchNumber = item.batchNumber;
		lVar.sequenceNumbe = item.sequenceNumbe;
		lVar.responsCodeId = item.responsCodeId;
	},
	[DELETE_TERMINAL](state, id) {
		state.terminallist = state.terminallist.filter((h) => h.id != id);
	},
};

export const terminals = {
	namespaced: true,
	state,
	actions,
	mutations,
};
